import { TextField, Typography, FormControlLabel, Checkbox, FormHelperText } from '@material-ui/core'
import React, { useState } from 'react'
import LoadingButton from '../LoadingButton'

export default function ApproveModal({onApprove, onClose, purchaseOrder}) {

  const [Comment, setComment] = useState("")
  const [isSaving, setIsSaving] = useState(false)
  const [IsEditsPreApproved, setIsEditsPreApproved] = useState(purchaseOrder.isEditsPreApproved || false)

  const updateComment = event => {
    const { value } = event.target;
    setComment(value);
  }

  const approve = () => {
    setIsSaving(true);
    onApprove(Comment, IsEditsPreApproved).then(res => {
      setIsSaving(false);
      onClose();
    });
  }

  return (
    <div style={{width: '400px'}}>
      <Typography variant='h6'>Approve purchase order</Typography>
      <div style={{margin: '24px 0 0px'}}>
        <TextField
          multiline
          label='Comment'
          placeholder='Write approval notes here'
          variant='outlined'
          InputLabelProps={{ shrink: true }}
          onChange={updateComment}
          rows={6}
          fullWidth
          value={Comment}
        />
      </div>
      <div style={{margin: '12px 0 32px'}}>
        <FormControlLabel
          control={
          <Checkbox variant='outlined'
            onChange={() => setIsEditsPreApproved(!IsEditsPreApproved)}
            checked={IsEditsPreApproved}
            color="primary" />
          }
          label="Pre-approve future edits"
        />
        <FormHelperText style={{margin: '-3px 0 0'}}>(Ticking this box allows users to edit this PO without further approval.)</FormHelperText>
      </div>
      <LoadingButton
        color="primary"
        variant="contained"
        fullWidth
        loading={isSaving}
        onClick={approve}
      >Approve</LoadingButton>
    </div>
  )
}